export const ROOM_TYPES = [
  'regular',
  'gym',
  'lab',
  'auditorium',
  'music'
] as const

export type RoomType = (typeof ROOM_TYPES)[number]
